import '@style/common/main-style'

import '@style/common/breadcrumbs.css'

import '@core/views/error/inBuild/index.css'
import '@style/common/text.css'
import '@style/common/button.css'

import './index.css'

import { deletePage } from '@utils/browserTest.ts'
import { generateContactElements } from '@core/views/contact/generate.ts'
import { generateInBuildElements } from '@core/views/error/inBuild'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(() => {
    if (import.meta.env.DEV) {
      generateInBuildElements(document, document.querySelector('main')!, false)
      generateContactElements(document)
    }

    removeCurrentPageClickEvent()
  })
})
